import { useEffect, useState } from "react";
import { oneOf } from "prop-types";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useStores } from "@hooks";
import { home } from "@paths";
import { Alert } from "@components";

export const ESTIMATE_ERROR_CODES = {
  PROJECT: "project",
  PROJECT_DELETED: "project_deleted",
  PROJECT_UNKNOWN: "project_unknown",
  TEMPLATE: "template",
  TEMPLATE_DELETED: "template_deleted",
  TEMPLATE_UNKNOWN: "template_unknown",
}

export const EstimateLoadingAlert = ({ code }) => {
  const { stateStore } = useStores();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [feedbackOpened, openFeedback] = useState(false);
  
  useEffect(() => {
    if (feedbackOpened && stateStore.openFeedback) handleAlertClose();
  }, [feedbackOpened, stateStore.openFeedback]);

  const handleAlertClose = () => {
    navigate(home);
  };

  const handleFeedbackOpen = () => {
    openFeedback(true);
    stateStore.setOpenFeedback(true);
  };

  return (
    <Alert
      title={t(`errors.editor.${code}.title`)}
      isOpen
      onAccept={handleAlertClose}
      onCancel={handleFeedbackOpen}
      acceptText={t("common.close")}
      cancelText={t("forms.contact.title")}
    >
      {t(`errors.editor.${code}.full`, { defaultValue: "" })}
    </Alert>
  );
};

EstimateLoadingAlert.propTypes = {
  code: oneOf(Object.values(ESTIMATE_ERROR_CODES)).isRequired,
};
